import { ReactComponent as AcademicCap } from '../assets/icons/academic-cap.svg';
import { ReactComponent as Add } from '../assets/icons/add.svg';
import { ReactComponent as AddTime } from '../assets/icons/add-time.svg';
import { ReactComponent as Adjustments } from '../assets/icons/adjustments.svg';
import { ReactComponent as Advertence } from '../assets/icons/advertence.svg';
import { ReactComponent as Annotation } from '../assets/icons/annotation.svg';
import { ReactComponent as Archive } from '../assets/icons/archive.svg';
import { ReactComponent as ArrowCircleDown } from '../assets/icons/arrow-circle-down.svg';
import { ReactComponent as ArrowCircleLeft } from '../assets/icons/arrow-circle-left.svg';
import { ReactComponent as ArrowCircleRight } from '../assets/icons/arrow-circle-right.svg';
import { ReactComponent as ArrowCircleUp } from '../assets/icons/arrow-circle-up.svg';
import { ReactComponent as ArrowDown } from '../assets/icons/arrow-down.svg';
import { ReactComponent as ArrowLeft } from '../assets/icons/arrow-left.svg';
import { ReactComponent as ArrowNarrowDown } from '../assets/icons/arrow-narrow-down.svg';
import { ReactComponent as ArrowNarrowLeft } from '../assets/icons/arrow-narrow-left.svg';
import { ReactComponent as ArrowNarrowRight } from '../assets/icons/arrow-narrow-right.svg';
import { ReactComponent as ArrowNarrowUp } from '../assets/icons/arrow-narrow-up.svg';
import { ReactComponent as ArrowRight } from '../assets/icons/arrow-right.svg';
import { ReactComponent as ArrowsExpand } from '../assets/icons/arrows-expand.svg';
import { ReactComponent as ArrowUp } from '../assets/icons/arrow-up.svg';
import { ReactComponent as AtSymbol } from '../assets/icons/at-symbol.svg';
import { ReactComponent as Backspace } from '../assets/icons/backspace.svg';
import { ReactComponent as BadgeCheck } from '../assets/icons/badge-check.svg';
import { ReactComponent as Ban } from '../assets/icons/ban.svg';
import { ReactComponent as Barcode } from '../assets/icons/barcode.svg';
import { ReactComponent as Beaker } from '../assets/icons/beaker.svg';
import { ReactComponent as Bell } from '../assets/icons/bell.svg';
import { ReactComponent as BellNotif } from '../assets/icons/bell_notif.svg';
import { ReactComponent as BookmarkAlt } from '../assets/icons/bookmark-alt.svg';
import { ReactComponent as Bookmark } from '../assets/icons/bookmark.svg';
import { ReactComponent as BookOpen } from '../assets/icons/book-open.svg';
import { ReactComponent as Box } from '../assets/icons/box.svg';
import { ReactComponent as Briefcase } from '../assets/icons/briefcase.svg';
import { ReactComponent as Bultos } from '../assets/icons/bultos.svg';
import { ReactComponent as Cake } from '../assets/icons/cake.svg';
import { ReactComponent as Calculator } from '../assets/icons/calculator.svg';
import { ReactComponent as Calendar } from '../assets/icons/calendar.svg';
import { ReactComponent as Camera } from '../assets/icons/camera.svg';
import { ReactComponent as Cash } from '../assets/icons/cash.svg';
import { ReactComponent as ChartBar } from '../assets/icons/chart-bar.svg';
import { ReactComponent as ChartPie } from '../assets/icons/chart-pie.svg';
import { ReactComponent as ChartSquareBar } from '../assets/icons/chart-square-bar.svg';
import { ReactComponent as ChatAlt2 } from '../assets/icons/chat-alt-2.svg';
import { ReactComponent as ChatAlt } from '../assets/icons/chat-alt.svg';
import { ReactComponent as Chat } from '../assets/icons/chat.svg';
import { ReactComponent as CheckCircle } from '../assets/icons/check-circle.svg';
import { ReactComponent as Check } from '../assets/icons/check.svg';
import { ReactComponent as ChevronDown } from '../assets/icons/chevron-down.svg';
import { ReactComponent as ChevronLeft } from '../assets/icons/chevron-left.svg';
import { ReactComponent as ChevronRight } from '../assets/icons/chevron-right.svg';
import { ReactComponent as ChevronUp } from '../assets/icons/chevron-up.svg';
import { ReactComponent as ChevronDoubleDown } from '../assets/icons/chevron-double-down.svg';
import { ReactComponent as ChevronDoubleLeft } from '../assets/icons/chevron-double-left.svg';
import { ReactComponent as ChevronDoubleRight } from '../assets/icons/chevron-double-right.svg';
import { ReactComponent as ChevronDoubleUp } from '../assets/icons/chevron-double-up.svg';
import { ReactComponent as Chip } from '../assets/icons/chip.svg';
import { ReactComponent as Circle } from '../assets/icons/circle.svg';
import { ReactComponent as ClipboardCheck } from '../assets/icons/clipboard-check.svg';
import { ReactComponent as ClipboardCopy } from '../assets/icons/clipboard-copy.svg';
import { ReactComponent as ClipboardList } from '../assets/icons/clipboard-list.svg';
import { ReactComponent as Clipboard } from '../assets/icons/clipboard.svg';
import { ReactComponent as Clock } from '../assets/icons/clock.svg';
import { ReactComponent as CloudDownload } from '../assets/icons/cloud-download.svg';
import { ReactComponent as Cloud } from '../assets/icons/cloud.svg';
import { ReactComponent as CloudUpload } from '../assets/icons/cloud-upload.svg';
import { ReactComponent as Code } from '../assets/icons/code.svg';
import { ReactComponent as Cog } from '../assets/icons/cog.svg';
import { ReactComponent as Collection } from '../assets/icons/collection.svg';
import { ReactComponent as ColorSwatch } from '../assets/icons/color-swatch.svg';
import { ReactComponent as CreditCard } from '../assets/icons/credit-card.svg';
import { ReactComponent as Cross } from '../assets/icons/cross.svg';
import { ReactComponent as CubeTransparent } from '../assets/icons/cube-transparent.svg';
import { ReactComponent as CurrencyBangladeshi } from '../assets/icons/currency-bangladeshi.svg';
import { ReactComponent as CurrencyDollar } from '../assets/icons/currency-dollar.svg';
import { ReactComponent as CurrencyEuro } from '../assets/icons/currency-euro.svg';
import { ReactComponent as CurrencyPound } from '../assets/icons/currency-pound.svg';
import { ReactComponent as CurrencyRupee } from '../assets/icons/currency-rupee.svg';
import { ReactComponent as CurrencyYen } from '../assets/icons/currency-yen.svg';
import { ReactComponent as CursorClick } from '../assets/icons/cursor-click.svg';
import { ReactComponent as Database } from '../assets/icons/database.svg';
import { ReactComponent as DesktopComputer } from '../assets/icons/desktop-computer.svg';
import { ReactComponent as DeviceMobile } from '../assets/icons/device-mobile.svg';
import { ReactComponent as DeviceTablet } from '../assets/icons/device-tablet.svg';
import { ReactComponent as DocumentAdd } from '../assets/icons/document-add.svg';
import { ReactComponent as DocumentDownload } from '../assets/icons/document-download.svg';
import { ReactComponent as DocumentDuplicate } from '../assets/icons/document-duplicate.svg';
import { ReactComponent as DocumentRemove } from '../assets/icons/document-remove.svg';
import { ReactComponent as DocumentReport } from '../assets/icons/document-report.svg';
import { ReactComponent as DocumentSearch } from '../assets/icons/document-search.svg';
import { ReactComponent as Document } from '../assets/icons/document.svg';
import { ReactComponent as DocumentText } from '../assets/icons/document-text.svg';
import { ReactComponent as DotsCircleHorizontal } from '../assets/icons/dots-circle-horizontal.svg';
import { ReactComponent as DotsHorizontal } from '../assets/icons/dots-horizontal.svg';
import { ReactComponent as DotsVertical } from '../assets/icons/dots-vertical.svg';
import { ReactComponent as Download } from '../assets/icons/download.svg';
import { ReactComponent as DropOff } from '../assets/icons/drop-off.svg';
import { ReactComponent as Duplicate } from '../assets/icons/duplicate.svg';
import { ReactComponent as EmojiHappy } from '../assets/icons/emoji-happy.svg';
import { ReactComponent as EmojiSad } from '../assets/icons/emoji-sad.svg';
import { ReactComponent as ExclamationCircle } from '../assets/icons/exclamation-circle.svg';
import { ReactComponent as Exclamation } from '../assets/icons/exclamation.svg';
import { ReactComponent as ExternalLink } from '../assets/icons/external-link.svg';
import { ReactComponent as EyeOff } from '../assets/icons/eye-off.svg';
import { ReactComponent as Eye } from '../assets/icons/eye.svg';
import { ReactComponent as FastForward } from '../assets/icons/fast-forward.svg';
import { ReactComponent as Film } from '../assets/icons/film.svg';
import { ReactComponent as Filter } from '../assets/icons/filter.svg';
import { ReactComponent as FingerPrint } from '../assets/icons/finger-print.svg';
import { ReactComponent as Fire } from '../assets/icons/fire.svg';
import { ReactComponent as Flag } from '../assets/icons/flag.svg';
import { ReactComponent as FolderAdd } from '../assets/icons/folder-add.svg';
import { ReactComponent as FolderDownload } from '../assets/icons/folder-download.svg';
import { ReactComponent as FolderFull } from '../assets/icons/folder-full.svg';
import { ReactComponent as FolderError } from '../assets/icons/folder-error.svg';
import { ReactComponent as FolderOpen } from '../assets/icons/folder-open.svg';
import { ReactComponent as FolderRemove } from '../assets/icons/folder-remove.svg';
import { ReactComponent as Folder } from '../assets/icons/folder.svg';
import { ReactComponent as Gift } from '../assets/icons/gift.svg';
import { ReactComponent as GlobeAlt } from '../assets/icons/globe-alt.svg';
import { ReactComponent as Globe } from '../assets/icons/globe.svg';
import { ReactComponent as Hand } from '../assets/icons/hand.svg';
import { ReactComponent as Hashtag } from '../assets/icons/hashtag.svg';
import { ReactComponent as Heart } from '../assets/icons/heart.svg';
import { ReactComponent as Historial } from '../assets/icons/historial.svg';
import { ReactComponent as Home } from '../assets/icons/home.svg';
import { ReactComponent as IconUserRemove } from '../assets/icons/icon-user-remove.svg';
import { ReactComponent as Identification } from '../assets/icons/identification.svg';
import { ReactComponent as InboxIn } from '../assets/icons/inbox-in.svg';
import { ReactComponent as Inbox } from '../assets/icons/inbox.svg';
import { ReactComponent as InformationCircle } from '../assets/icons/information-circle.svg';
import { ReactComponent as Key } from '../assets/icons/key.svg';
import { ReactComponent as Less } from '../assets/icons/less.svg';
import { ReactComponent as Library } from '../assets/icons/library.svg';
import { ReactComponent as LightBulb } from '../assets/icons/light-bulb.svg';
import { ReactComponent as LightingBolt } from '../assets/icons/lightning-bolt.svg';
import { ReactComponent as Link } from '../assets/icons/link.svg';
import { ReactComponent as LocationBox } from '../assets/icons/location-box.svg';
import { ReactComponent as LocationMarker } from '../assets/icons/location-marker.svg';
import { ReactComponent as LockClosed } from '../assets/icons/lock-closed.svg';
import { ReactComponent as LockOpen } from '../assets/icons/lock-open.svg';
import { ReactComponent as Login } from '../assets/icons/login.svg';
import { ReactComponent as Logout } from '../assets/icons/logout.svg';
import { ReactComponent as MailOpen } from '../assets/icons/mail-open.svg';
import { ReactComponent as Mail } from '../assets/icons/mail.svg';
import { ReactComponent as Map } from '../assets/icons/map.svg';
import { ReactComponent as MenuAlt1 } from '../assets/icons/menu-alt-1.svg';
import { ReactComponent as MenuAlt2 } from '../assets/icons/menu-alt-2.svg';
import { ReactComponent as MenuAlt3 } from '../assets/icons/menu-alt-3.svg';
import { ReactComponent as MenuAlt4 } from '../assets/icons/menu-alt-4.svg';
import { ReactComponent as Menu } from '../assets/icons/menu.svg';
import { ReactComponent as Microphone } from '../assets/icons/microphone.svg';
import { ReactComponent as MinusCircle } from '../assets/icons/minus-circle.svg';
import { ReactComponent as Minus } from '../assets/icons/minus.svg';
import { ReactComponent as Moon } from '../assets/icons/moon.svg';
import { ReactComponent as MusicNote } from '../assets/icons/music-note.svg';
import { ReactComponent as Newspaper } from '../assets/icons/newspaper.svg';
import { ReactComponent as OfficeBuilding } from '../assets/icons/office-building.svg';
import { ReactComponent as Operar } from '../assets/icons/operar.svg';
import { ReactComponent as PaperAirplane } from '../assets/icons/paper-airplane.svg';
import { ReactComponent as PaperClip } from '../assets/icons/paper-clip.svg';
import { ReactComponent as Pause } from '../assets/icons/pause.svg';
import { ReactComponent as PencilAlt } from '../assets/icons/pencil-alt.svg';
import { ReactComponent as Pencil } from '../assets/icons/pencil.svg';
import { ReactComponent as PhoneIncoming } from '../assets/icons/phone-incoming.svg';
import { ReactComponent as PhoneMissedCall } from '../assets/icons/phone-missed-call.svg';
import { ReactComponent as PhoneOutgoing } from '../assets/icons/phone-outgoing.svg';
import { ReactComponent as Phone } from '../assets/icons/phone.svg';
import { ReactComponent as Photograph } from '../assets/icons/photograph.svg';
import { ReactComponent as Play } from '../assets/icons/play.svg';
import { ReactComponent as PlusCircle } from '../assets/icons/plus-circle.svg';
import { ReactComponent as Plus } from '../assets/icons/plus.svg';
import { ReactComponent as PresentationChartBar } from '../assets/icons/presentation-chart-bar.svg';
import { ReactComponent as PresentationChartLine } from '../assets/icons/presentation-chart-line.svg';
import { ReactComponent as Printer } from '../assets/icons/printer.svg';
import { ReactComponent as Process } from '../assets/icons/process.svg';
import { ReactComponent as Puzzle } from '../assets/icons/puzzle.svg';
import { ReactComponent as Qrcode } from '../assets/icons/qrcode.svg';
import { ReactComponent as QuestionMarkCircle } from '../assets/icons/question-mark-circle.svg';
import { ReactComponent as Receipt } from '../assets/icons/receipt.svg';
import { ReactComponent as ReceiptRefund } from '../assets/icons/receipt-refund.svg';
import { ReactComponent as ReceiptTax } from '../assets/icons/receipt-tax.svg';
import { ReactComponent as Refresh } from '../assets/icons/refresh.svg';
import { ReactComponent as Reply } from '../assets/icons/reply.svg';
import { ReactComponent as Rewind } from '../assets/icons/rewind.svg';
import { ReactComponent as Rss } from '../assets/icons/rss.svg';
import { ReactComponent as SaveAs } from '../assets/icons/save-as.svg';
import { ReactComponent as Save } from '../assets/icons/save.svg';
import { ReactComponent as Scale } from '../assets/icons/scale.svg';
import { ReactComponent as Scan } from '../assets/icons/scan.svg';
import { ReactComponent as Scissors } from '../assets/icons/scissors.svg';
import { ReactComponent as SearchCircle } from '../assets/icons/search-circle.svg';
import { ReactComponent as Search } from '../assets/icons/search.svg';
import { ReactComponent as Selector } from '../assets/icons/selector.svg';
import { ReactComponent as Server } from '../assets/icons/server.svg';
import { ReactComponent as Share } from '../assets/icons/share.svg';
import { ReactComponent as ShieldCheck } from '../assets/icons/shield-check.svg';
import { ReactComponent as ShieldExclamation } from '../assets/icons/shield-exclamation.svg';
import { ReactComponent as ShipOk } from '../assets/icons/ship-ok.svg';
import { ReactComponent as ShoppingBag } from '../assets/icons/shopping-bag.svg';
import { ReactComponent as ShoppingCart } from '../assets/icons/shopping-cart.svg';
import { ReactComponent as SmViewGridAdd } from '../assets/icons/sm-view-grid-add.svg';
import { ReactComponent as SortAscending } from '../assets/icons/sort-ascending.svg';
import { ReactComponent as SortDescending } from '../assets/icons/sort-descending.svg';
import { ReactComponent as Sparkles } from '../assets/icons/sparkles.svg';
import { ReactComponent as Speakerphone } from '../assets/icons/speakerphone.svg';
import { ReactComponent as Spinner } from '../assets/icons/spinner.svg';
import { ReactComponent as Star } from '../assets/icons/star.svg';
import { ReactComponent as StatusOffline } from '../assets/icons/status-offline.svg';
import { ReactComponent as StatusOnline } from '../assets/icons/status-online.svg';
import { ReactComponent as Stop } from '../assets/icons/stop.svg';
import { ReactComponent as SubtractTime } from '../assets/icons/subtract-time.svg';
import { ReactComponent as Sun } from '../assets/icons/sun.svg';
import { ReactComponent as SupportService } from '../assets/icons/support-service.svg';
import { ReactComponent as Support } from '../assets/icons/support.svg';
import { ReactComponent as SwitchHorizontal } from '../assets/icons/switch-horizontal.svg';
import { ReactComponent as SwitchVertical } from '../assets/icons/switch-vertical.svg';
import { ReactComponent as Table } from '../assets/icons/table.svg';
import { ReactComponent as Tag } from '../assets/icons/tag.svg';
import { ReactComponent as Template } from '../assets/icons/template.svg';
import { ReactComponent as Terminal } from '../assets/icons/terminal.svg';
import { ReactComponent as ThumbDown } from '../assets/icons/thumb-down.svg';
import { ReactComponent as ThumbUp } from '../assets/icons/thumb-up.svg';
import { ReactComponent as Ticket } from '../assets/icons/ticket.svg';
import { ReactComponent as Translate } from '../assets/icons/translate.svg';
import { ReactComponent as Trash } from '../assets/icons/trash.svg';
import { ReactComponent as TrendingDown } from '../assets/icons/trending-down.svg';
import { ReactComponent as TrendingUp } from '../assets/icons/trending-up.svg';
import { ReactComponent as Truck } from '../assets/icons/truck.svg';
import { ReactComponent as Unlink } from '../assets/icons/unlink.svg';
import { ReactComponent as Upload } from '../assets/icons/upload.svg';
import { ReactComponent as UserAdd } from '../assets/icons/user-add.svg';
import { ReactComponent as UserCircle } from '../assets/icons/user-circle.svg';
import { ReactComponent as UserGroup } from '../assets/icons/user-group.svg';
import { ReactComponent as Users } from '../assets/icons/users.svg';
import { ReactComponent as User } from '../assets/icons/user.svg';
import { ReactComponent as Variable } from '../assets/icons/variable.svg';
import { ReactComponent as VideoCamera } from '../assets/icons/video-camera.svg';
import { ReactComponent as ViewBoards } from '../assets/icons/view-boards.svg';
import { ReactComponent as ViewGrid } from '../assets/icons/view-grid.svg';
import { ReactComponent as ViewList } from '../assets/icons/view-list.svg';
import { ReactComponent as VolumeOff } from '../assets/icons/volume-off.svg';
import { ReactComponent as VolumeUp } from '../assets/icons/volume-up.svg';
import { ReactComponent as Wallet } from '../assets/icons/wallet.svg';
import { ReactComponent as Whatsapp } from '../assets/icons/whatsapp.svg';
import { ReactComponent as Wifi } from '../assets/icons/wifi.svg';
import { ReactComponent as XCircle } from '../assets/icons/x-circle.svg';
import { ReactComponent as X } from '../assets/icons/x.svg';
import { ReactComponent as ZoomIn } from '../assets/icons/zoom-in.svg';
import { ReactComponent as ZoomOut } from '../assets/icons/zoom-out.svg';

export const icons = {
  'academic-cap': AcademicCap,
  add: Add,
  adjustments: Adjustments,
  advertence: Advertence,
  annotation: Annotation,
  archive: Archive,
  'arrow-circle-down': ArrowCircleDown,
  'arrow-circle-left': ArrowCircleLeft,
  'arrow-circle-right': ArrowCircleRight,
  'arrow-circle-up': ArrowCircleUp,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-narrow-down': ArrowNarrowDown,
  'arrow-narrow-left': ArrowNarrowLeft,
  'arrow-narrow-right': ArrowNarrowRight,
  'arrow-narrow-up': ArrowNarrowUp,
  'arrow-right': ArrowRight,
  'arrows-expand': ArrowsExpand,
  'arrow-up': ArrowUp,
  'at-symbol': AtSymbol,
  backspace: Backspace,
  'badge-check': BadgeCheck,
  ban: Ban,
  barcode: Barcode,
  beaker: Beaker,
  bell: Bell,
  'bell-notif': BellNotif,
  'bookmark-alt': BookmarkAlt,
  bookmark: Bookmark,
  'book-open': BookOpen,
  box: Box,
  briefcase: Briefcase,
  bultos: Bultos,
  cake: Cake,
  calculator: Calculator,
  calendar: Calendar,
  camera: Camera,
  cash: Cash,
  'chart-bar': ChartBar,
  'chart-pie': ChartPie,
  'chart-square-bar': ChartSquareBar,
  'chat-alt-2': ChatAlt2,
  'chat-alt': ChatAlt,
  chat: Chat,
  'check-circle': CheckCircle,
  check: Check,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'chevron-double-down': ChevronDoubleDown,
  'chevron-double-left': ChevronDoubleLeft,
  'chevron-double-right': ChevronDoubleRight,
  'chevron-double-up': ChevronDoubleUp,
  chip: Chip,
  circle: Circle,
  'clipboard-check': ClipboardCheck,
  'clipboard-copy': ClipboardCopy,
  'clipboard-list': ClipboardList,
  clipboard: Clipboard,
  clock: Clock,
  'clock-plus': AddTime,
  'clock-less': SubtractTime,
  'cloud-download': CloudDownload,
  cloud: Cloud,
  'cloud-upload': CloudUpload,
  code: Code,
  cog: Cog,
  collection: Collection,
  'color-swatch': ColorSwatch,
  'credit-card': CreditCard,
  cross: Cross,
  'cube-transparent': CubeTransparent,
  'currency-bangladeshi': CurrencyBangladeshi,
  'currency-dollar': CurrencyDollar,
  'currency-euro': CurrencyEuro,
  'currency-pound': CurrencyPound,
  'currency-rupee': CurrencyRupee,
  'currency-yen': CurrencyYen,
  'cursor-click': CursorClick,
  database: Database,
  'desktop-computer': DesktopComputer,
  'device-mobile': DeviceMobile,
  'device-tablet': DeviceTablet,
  'document-add': DocumentAdd,
  'document-download': DocumentDownload,
  'document-duplicate': DocumentDuplicate,
  'document-remove': DocumentRemove,
  'document-report': DocumentReport,
  'document-search': DocumentSearch,
  document: Document,
  'document-text': DocumentText,
  'dots-circle-horizontal': DotsCircleHorizontal,
  'dots-horizontal': DotsHorizontal,
  'dots-vertical': DotsVertical,
  download: Download,
  'drop-off': DropOff,
  duplicate: Duplicate,
  'emoji-happy': EmojiHappy,
  'emoji-sad': EmojiSad,
  'exclamation-circle': ExclamationCircle,
  exclamation: Exclamation,
  'external-link': ExternalLink,
  'eye-off': EyeOff,
  eye: Eye,
  'fast-forward': FastForward,
  film: Film,
  filter: Filter,
  'finger-print': FingerPrint,
  fire: Fire,
  flag: Flag,
  'folder-add': FolderAdd,
  'folder-download': FolderDownload,
  'folder-full': FolderFull,
  'folder-error': FolderError,
  'folder-open': FolderOpen,
  'folder-remove': FolderRemove,
  folder: Folder,
  gift: Gift,
  'globe-alt': GlobeAlt,
  globe: Globe,
  hand: Hand,
  hashtag: Hashtag,
  heart: Heart,
  historial: Historial,
  home: Home,
  'icon-user-remove': IconUserRemove,
  identification: Identification,
  'inbox-in': InboxIn,
  inbox: Inbox,
  'information-circle': InformationCircle,
  key: Key,
  less: Less,
  library: Library,
  'light-bulb': LightBulb,
  'lightning-bolt': LightingBolt,
  link: Link,
  'location-box': LocationBox,
  'location-marker': LocationMarker,
  'lock-closed': LockClosed,
  'lock-open': LockOpen,
  login: Login,
  logout: Logout,
  'mail-open': MailOpen,
  mail: Mail,
  map: Map,
  'menu-alt-1': MenuAlt1,
  'menu-alt-2': MenuAlt2,
  'menu-alt-3': MenuAlt3,
  'menu-alt-4': MenuAlt4,
  menu: Menu,
  microphone: Microphone,
  'minus-circle': MinusCircle,
  minus: Minus,
  moon: Moon,
  'music-note': MusicNote,
  newspaper: Newspaper,
  'office-building': OfficeBuilding,
  operar: Operar,
  'paper-airplane': PaperAirplane,
  'paper-clip': PaperClip,
  pause: Pause,
  'pencil-alt': PencilAlt,
  pencil: Pencil,
  'phone-incoming': PhoneIncoming,
  'phone-missed-call': PhoneMissedCall,
  'phone-outgoing': PhoneOutgoing,
  phone: Phone,
  photograph: Photograph,
  play: Play,
  'plus-circle': PlusCircle,
  plus: Plus,
  'presentation-chart-bar': PresentationChartBar,
  'presentation-chart-line': PresentationChartLine,
  printer: Printer,
  process: Process,
  puzzle: Puzzle,
  qrcode: Qrcode,
  'question-mark-circle': QuestionMarkCircle,
  receipt: Receipt,
  'receipt-refund': ReceiptRefund,
  'receipt-tax': ReceiptTax,
  refresh: Refresh,
  reply: Reply,
  rewind: Rewind,
  rss: Rss,
  'save-as': SaveAs,
  save: Save,
  scale: Scale,
  scan: Scan,
  scissors: Scissors,
  'search-circle': SearchCircle,
  search: Search,
  selector: Selector,
  server: Server,
  share: Share,
  'shield-check': ShieldCheck,
  'shield-exclamation': ShieldExclamation,
  'ship-ok': ShipOk,
  'shopping-bag': ShoppingBag,
  'shopping-cart': ShoppingCart,
  'sm-view-grid-add': SmViewGridAdd,
  'sort-ascending': SortAscending,
  'sort-descending': SortDescending,
  sparkles: Sparkles,
  speakerphone: Speakerphone,
  spinner: Spinner,
  star: Star,
  'status-offline': StatusOffline,
  'status-online': StatusOnline,
  stop: Stop,
  sun: Sun,
  'support-service': SupportService,
  support: Support,
  'switch-horizontal': SwitchHorizontal,
  'switch-vertical': SwitchVertical,
  table: Table,
  tag: Tag,
  template: Template,
  terminal: Terminal,
  'thumb-down': ThumbDown,
  'thumb-up': ThumbUp,
  ticket: Ticket,
  translate: Translate,
  trash: Trash,
  'trending-down': TrendingDown,
  'trending-up': TrendingUp,
  truck: Truck,
  unlink: Unlink,
  upload: Upload,
  'user-add': UserAdd,
  'user-circle': UserCircle,
  'user-group': UserGroup,
  users: Users,
  user: User,
  variable: Variable,
  'video-camera': VideoCamera,
  'view-boards': ViewBoards,
  'view-grid': ViewGrid,
  'view-list': ViewList,
  'volume-off': VolumeOff,
  'volume-up': VolumeUp,
  wallet: Wallet,
  whatsapp: Whatsapp,
  wifi: Wifi,
  'x-circle': XCircle,
  x: X,
  'zoom-in': ZoomIn,
  'zoom-out': ZoomOut,
};
